//This slice is for filters, sorting and drag&drop for live events dashboard. 

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EventTypeFilter } from "../../Models/EventTypeFilter";

const STORED_FILTER_SORT_CONFIG = "ots:filterSortConfig";

interface FilterSortState {
    filters: EventTypeFilter[];
    sort: string;
    dragAndDropEventList: string[];
  }

//Retrieves the backup of filterSort from local storage, if found initalizes the state with the backup.
const storedFilterSortConfig = localStorage.getItem(STORED_FILTER_SORT_CONFIG);
const initialState: FilterSortState = storedFilterSortConfig ? JSON.parse(storedFilterSortConfig) : {
    filters: [],
    sort: "Hours Open-2",
    dragAndDropEventList: [],
  };  

  export const FilterSortSlice = createSlice({
    name: "filterSort",
    initialState,
    reducers: {
      setFilters: (state, action: PayloadAction<EventTypeFilter[]>) => {
        state.filters = action.payload;
      },
      setSort: (state, action: PayloadAction<string>) => {
        state.sort = action.payload;
      },
      setDragAndDropEventList: (state, action: PayloadAction<string[]>) => {
        state.dragAndDropEventList = action.payload;
    },
    },
  });
  
  export default FilterSortSlice;
  export const { setFilters, setSort, setDragAndDropEventList } = FilterSortSlice.actions;